import { logError } from "@/lib/log";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Idempotent guard for React StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        // clean hash so re-visits do not re-process
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        toast.success("Signed in with Google");
        navigate("/app", { replace: true });
      } catch (e) {
        logError("Google session exchange failed", e);
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F5F0]">
      <div className="text-center">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#A67C00] mb-3">One moment</div>
        <div className="font-serif text-3xl tracking-tight">Opening your ledger…</div>
      </div>
    </div>
  );
}
